module.exports = __webpack_public_path__ + "img/document.d0b6415c.png";